import { useMutation, useQuery } from '@apollo/client'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Box, Button, Flex, Text } from 'rebass/styled-components'

import { CUSTOMER_ADDRESS_CREATE, CUSTOMER_ADDRESS_UPDATE } from '../../graphql/mutations'
import { CUSTOMER_ADDRESS } from '../../graphql/queries'
import { storage, Toast } from '../../utils'
import items from './items'
import datas from './province'
import Header from '../../components/Header'
import IonContent from '../../components/IonContent'
import {
    IonPage,
    IonLoading,
    IonItem,
    IonLabel,
    IonButton,
    IonInput,
    IonSelect,
    IonSelectOption,
} from '@ionic/react'

const getInfo = (d) => d?.customer?.addresses?.edges[0]?.node

const initState = {
    firstName: '',
    lastName: '',
    address1: '',
    address2: '',
    city: '',
    country: 'United States',
    province: '',
    phone: '',
    zip: '',
}

export default () => {
    const [obj, setObj] = useState(initState)
    const [editting, setEditting] = useState(false)

    const token = storage.getItem('accessToken')

    const handleChange = (type) => (e) => {
        setObj({
            ...obj,
            [type]: e.target.value,
        })
    }

    if (!token) {
        return (
            <IonPage>
                <Header title="Address"></Header>
                <IonContent>
                    <Box mt="30px" px="20px">
                        <Link to="/login">
                            <Text>
                                Please
                                <Text as="span" ml="10px">
                                    Login
                                </Text>
                            </Text>
                        </Link>
                    </Box>
                </IonContent>
            </IonPage>
        )
    }
    const { data, loading, refetch } = useQuery(CUSTOMER_ADDRESS, {
        variables: {
            customerAccessToken: token,
        },
        onCompleted: (d) => {
            const info = getInfo(d) || {}
            if (info) {
                const val = Object.keys(initState).reduce(
                    (left, right) => ({
                        ...left,
                        [right]: right === 'country' ? 'United States' : info[right],
                    }),
                    {}
                )
                setObj(val)
            }
        },
    })

    const info = getInfo(data) || {}
    const [mutate, { loading: loadingUpdate }] = useMutation(CUSTOMER_ADDRESS_UPDATE, {
        onCompleted({ customerAddressUpdate }) {
            if (customerAddressUpdate.customerAddress) {
                handleSuccess()
            }
        },
    })
    const [mutateCreate, { loading: loadingCreate }] = useMutation(CUSTOMER_ADDRESS_CREATE, {
        onCompleted({ customerAddressCreate }) {
            if (customerAddressCreate.customerAddress) {
                handleSuccess()
            }
        },
    })
    const handleSuccess = () => {
        refetch()
        setEditting(false)
        Toast('Success!')
    }
    const handleSave = () => {
        const action = info.id ? mutate : mutateCreate
        action({
            variables: {
                customerAccessToken: token,
                address: {
                    ...obj,
                },
                id: info.id,
            },
        })
    }

    return (
        <IonPage>
            <Header title="Address"></Header>
            <IonContent>
                <IonLoading isOpen={loading || loadingUpdate || loadingCreate}></IonLoading>
                {editting ? (
                    <Box>
                        {items.map((item, index) =>
                            item.key === 'province' ? (
                                <IonItem>
                                    <IonLabel>{item.label}</IonLabel>
                                    <IonSelect
                                        value={obj[item.key]}
                                        placeholder="Select One"
                                        onIonChange={handleChange(item.key)}
                                    >
                                        {datas.provinces.map((item, i) => (
                                            <IonSelectOption value={item.name} key={i}>
                                                {item.name}
                                            </IonSelectOption>
                                        ))}
                                    </IonSelect>
                                </IonItem>
                            ) : (
                                <IonItem>
                                    <IonLabel>{item.label}</IonLabel>
                                    <IonInput
                                        key={index}
                                        // title={}
                                        value={obj[item.key]}
                                        disabled={item.key === 'country'}
                                        onIonChange={handleChange(item.key)}
                                    />
                                </IonItem>
                            )
                        )}

                        <Flex justifyContent="space-between" px="20px">
                            <IonButton
                                color="warning"
                                expand="block"
                                style={{ width: '50%' }}
                                onClick={() => setEditting(false)}
                            >
                                Cancel
                            </IonButton>
                            <IonButton expand="block" style={{ width: '50%' }} onClick={handleSave}>
                                Save
                            </IonButton>
                        </Flex>
                    </Box>
                ) : (
                    <Box px="20px">
                        <Text>{[info.firstName, info.lastName].join(' ')}</Text>
                        <Text>{[info.address1, info.address2].join(' ')}</Text>
                        <Text>{[info.city, info.province, info.zip].join(' ')}</Text>
                        <Text>{info.country}</Text>

                        <Box mt="20px">
                            <IonButton expand="block" onClick={() => setEditting(true)}>
                                {info.id ? 'Edit' : 'Create'}
                            </IonButton>
                        </Box>
                    </Box>
                )}
            </IonContent>
        </IonPage>
    )
}
